// src/lib/dom.js — helpers de DOM e sanitização.

/**
 * Escape HTML — sanitização básica anti-XSS para strings injetadas em innerHTML.
 * Idempotente; null/undefined viram string vazia.
 */
export function esc(s) {
  if (s === null || s === undefined) return '';
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * Inicia letras (avatar fallback).
 * "Maite Morato" → "MM", "João" → "J".
 */
export function initials(name) {
  if (!name) return '?';
  return String(name)
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();
}

/**
 * Renderiza HTML em #main-content (ou outro alvo).
 * Substitui o uso direto de document.getElementById('main-content').innerHTML.
 */
export function mount(html, selector = '#main-content') {
  const el = document.querySelector(selector);
  if (!el) {
    console.warn(`[dom.mount] seletor não encontrado: ${selector}`);
    return null;
  }
  el.innerHTML = html;
  return el;
}

export function getMain() {
  return document.getElementById('main-content');
}

/**
 * Focus trap para modais e drawers (o cânone shadcn: Dialog/Sheet prendem o foco).
 * Nenhum overlay do ERP fazia isto — com o modal aberto, o Tab passeava pela tela de
 * TRÁS dele, e ao fechar o foco não voltava para quem abriu.
 *
 *   const soltar = trapFocus(elemento);   // prende; foca o 1º campo
 *   soltar();                             // solta e devolve o foco ao disparador
 *
 * Devolve uma função de limpeza — chame-a no close do overlay.
 */
export function trapFocus(container) {
  const anterior = document.activeElement;
  const SELETOR = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),'
    + 'textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  const foco = () => [...container.querySelectorAll(SELETOR)].filter((el) => el.offsetParent !== null);

  const onKey = (e) => {
    if (e.key !== 'Tab') return;
    const els = foco();
    if (!els.length) return;
    const primeiro = els[0], ultimo = els[els.length - 1];
    if (e.shiftKey && document.activeElement === primeiro) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primeiro.focus(); }
  };
  container.addEventListener('keydown', onKey);

  // foca o primeiro campo (ou o próprio container) — sem isto o teclado começa "fora"
  requestAnimationFrame(() => { (foco()[0] || container).focus?.(); });

  return () => {
    container.removeEventListener('keydown', onKey);
    if (anterior && typeof anterior.focus === 'function') anterior.focus();
  };
}
